
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../components/Logo';
import NavLink from '../../components/NavLink';

export default function Services() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white  transition-colors" style={{ fontFamily: 'Prompt, sans-serif' }}>
      {/* Navigation */}
      <nav className="absolute top-0 left-0 right-0 z-50 bg-transparent">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-start py-4">
            <div className="flex items-start">
              <Link to="/">
                <Logo size="md" className="hover:scale-105 transition-transform cursor-pointer" />
              </Link>
            </div>
            
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8 pt-4">
                <NavLink to="/">HOME</NavLink>
                <NavLink to="/about">ABOUT</NavLink>
                <NavLink to="/services">SERVICES</NavLink>
                <NavLink to="/products">PROJECTS</NavLink>
                <NavLink to="/contact">CONTACT</NavLink>
              </div>
            </div>

            <div className="hidden md:flex items-center space-x-4 pt-4">
              <Link to="/contact" className="bg-zbm-secondary hover:bg-zbm-secondary-dark text-white px-6 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer drop-shadow-lg">
                Get a Quote
              </Link>
            </div>

            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-zbm-primary hover:text-zbm-primary-dark cursor-pointer drop-shadow-lg"
              >
                <i className="ri-menu-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white/95 /95 backdrop-blur-sm border-t border-gray-100 ">
              <NavLink to="/" mobile={true}>HOME</NavLink>
              <NavLink to="/about" mobile={true}>ABOUT</NavLink>
              <NavLink to="/services" mobile={true}>SERVICES</NavLink>
              <NavLink to="/products" mobile={true}>PROJECTS</NavLink>
              <NavLink to="/contact" mobile={true}>CONTACT</NavLink>
              <Link to="/contact" className="bg-zbm-secondary hover:bg-zbm-secondary-dark text-white px-6 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer w-full mt-2">
                Get a Quote
              </Link>
            </div>
          </div>
        )}
      </nav>

      {/* Header Separator Line */}
      <div className="w-full h-px bg-gray-300 mt-32"></div>

      {/* Hero Section */}
      <section className="relative pt-20 pb-20" style={{ backgroundColor: '#F7F7F7' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl lg:text-6xl font-extrabold text-gray-900  mb-6" style={{ fontFamily: 'Prompt, sans-serif' }}>
            Our
            <span className="text-zbm-primary block">Services</span>
          </h1>
          <p className="text-xl text-gray-600  mb-8 max-w-3xl mx-auto leading-relaxed font-normal">
            Comprehensive construction and civil engineering solutions delivered with excellence, from project conception to completion.
          </p>
          <div className="flex items-center justify-center mb-8">
            <span className="text-2xl mr-3">🏗️</span>
            <p className="text-lg font-semibold text-gray-700 ">Professional. Reliable. Quality-Driven.</p>
          </div>
        </div>
      </section>

      {/* Project Management Services */}
      <section className="py-20 bg-white ">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900  mb-6" style={{ fontFamily: 'Prompt, sans-serif' }}>Construction Project Management</h2>
            <p className="text-xl text-gray-600  max-w-3xl mx-auto font-normal">
              Professional oversight and management of construction projects from planning to completion.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-gradient-to-br from-zbm-light to-white  p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow text-center">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" style={{ backgroundColor: '#1E3A8A' }}>
                <i className="ri-lightbulb-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>IBT Projects</h3>
              <p className="text-gray-600  font-normal">
                Innovative Building Technology projects managed with expertise and attention to detail.
              </p>
            </div>

            <div className="bg-gradient-to-br from-zbm-light to-white  p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow text-center">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" style={{ backgroundColor: '#EA580C' }}>
                <i className="ri-home-4-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Residential Development</h3>
              <p className="text-gray-600  font-normal">
                Complete residential development projects from planning to handover.
              </p>
            </div>

            <div className="bg-gradient-to-br from-zbm-light to-white  p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow text-center">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" style={{ backgroundColor: '#1E3A8A' }}>
                <i className="ri-draft-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Civil & Structural Engineering</h3>
              <p className="text-gray-600  font-normal">
                Professional civil and structural engineering project management services.
              </p>
            </div>

            <div className="bg-gradient-to-br from-zbm-light to-white  p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow text-center">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" style={{ backgroundColor: '#EA580C' }}>
                <i className="ri-community-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>RDP Projects</h3>
              <p className="text-gray-600  font-normal">
                Reconstruction and Development Programme projects supporting community growth.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Construction Services */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-zbm-light dark:from-gray-800 dark:to-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900  mb-6" style={{ fontFamily: 'Prompt, sans-serif' }}>Building & Construction Services</h2>
            <p className="text-xl text-gray-600  max-w-3xl mx-auto font-normal">
              Full-spectrum construction services from foundations to finishing touches.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white  p-8 rounded-2xl shadow-lg">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-6" style={{ backgroundColor: '#1E3A8A' }}>
                <i className="ri-building-3-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Prefabricated Structures</h3>
              <ul className="text-gray-600  space-y-2 font-normal">
                <li>• Site Offices</li>
                <li>• Classrooms</li>
                <li>• Modular Homes</li>
              </ul>
            </div>

            <div className="bg-white  p-8 rounded-2xl shadow-lg">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-6" style={{ backgroundColor: '#EA580C' }}>
                <i className="ri-settings-3-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Steel & Metal Works</h3>
              <ul className="text-gray-600  space-y-2 font-normal">
                <li>• Steel Fixing</li>
                <li>• Steel Structures</li>
                <li>• Burglar Guards & Gates</li>
                <li>• Carports & Palisades</li>
              </ul>
            </div>

            <div className="bg-white  p-8 rounded-2xl shadow-lg">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-6" style={{ backgroundColor: '#1E3A8A' }}>
                <i className="ri-building-2-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Building Works</h3>
              <ul className="text-gray-600  space-y-2 font-normal">
                <li>• Civil Works</li>
                <li>• Foundations & Plinth</li>
                <li>• Brickwork & Plastering</li>
                <li>• Tiling & Painting</li>
              </ul>
            </div>

            <div className="bg-white  p-8 rounded-2xl shadow-lg">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-6" style={{ backgroundColor: '#EA580C' }}>
                <i className="ri-contrast-drop-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Concrete Works</h3>
              <ul className="text-gray-600  space-y-2 font-normal">
                <li>• Concrete Works</li>
                <li>• Power Floating</li>
                <li>• Saw Cuts</li>
              </ul>
            </div>

            <div className="bg-white  p-8 rounded-2xl shadow-lg">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-6" style={{ backgroundColor: '#1E3A8A' }}>
                <i className="ri-tools-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Carpentry Services</h3>
              <ul className="text-gray-600  space-y-2 font-normal">
                <li>• Roof & Ceiling Installation</li>
                <li>• Doors & Skirting</li>
                <li>• Outdoor Sundecks</li>
                <li>• Shuttering</li>
              </ul>
            </div>

            <div className="bg-white  p-8 rounded-2xl shadow-lg">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-6" style={{ backgroundColor: '#EA580C' }}>
                <i className="ri-paint-brush-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Finishing Services</h3>
              <ul className="text-gray-600  space-y-2 font-normal">
                <li>• Plumbing</li>
                <li>• Cupboards</li>
                <li>• Glazing</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Infrastructure Services */}
      <section className="py-20 bg-white ">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900  mb-6" style={{ fontFamily: 'Prompt, sans-serif' }}>Infrastructure & Utilities</h2>
            <p className="text-xl text-gray-600  max-w-3xl mx-auto font-normal">
              Essential infrastructure development and utility services for communities and developments.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-zbm-light to-white  p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mb-6" style={{ backgroundColor: '#1E3A8A' }}>
                <i className="ri-water-flash-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Water Infrastructure</h3>
              <p className="text-gray-600  mb-4 font-normal">
                Complete water reticulation projects including supply systems, storage tanks, and distribution networks.
              </p>
            </div>

            <div className="bg-gradient-to-br from-zbm-light to-white  p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mb-6" style={{ backgroundColor: '#EA580C' }}>
                <i className="ri-truck-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Plant Hire Services</h3>
              <p className="text-gray-600  mb-4 font-normal">
                Professional plant and equipment hire services with experienced operators for all construction needs.
              </p>
            </div>

            <div className="bg-gradient-to-br from-zbm-light to-white  p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mb-6" style={{ backgroundColor: '#1E3A8A' }}>
                <i className="ri-road-map-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Civil Engineering</h3>
              <p className="text-gray-600  mb-4 font-normal">
                Professional civil engineering services including road works, drainage systems, and site development.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Visual Showcase Section */}
      <section className="py-20 bg-white ">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900  mb-6" style={{ fontFamily: 'Prompt, sans-serif' }}>Our Work in Action</h2>
            <p className="text-xl text-gray-600  max-w-3xl mx-auto font-normal">
              See our construction excellence across various projects
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { img: 3, title: "Building Construction", desc: "Quality workmanship in every build" },
              { img: 10, title: "Steel Structures", desc: "Precision engineering and installation" },
              { img: 15, title: "Water Infrastructure", desc: "Essential utility development" },
              { img: 20, title: "Residential Projects", desc: "Creating homes and communities" },
              { img: 26, title: "Civil Engineering", desc: "Infrastructure that lasts" },
              { img: 33, title: "Project Management", desc: "Professional oversight and delivery" }
            ].map((item, index) => (
              <div key={index} className="relative overflow-hidden rounded-2xl shadow-lg group">
                <img 
                  src={`/projects/zbm-projects (${item.img}).jpeg`}
                  alt={item.title}
                  className="w-full h-80 object-cover group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent">
                  <div className="absolute bottom-6 left-6 right-6">
                    <h3 className="text-white text-2xl font-bold mb-2" style={{ fontFamily: 'Prompt, sans-serif' }}>{item.title}</h3>
                    <p className="text-white/90 text-sm">{item.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Partners/Clients Section */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-zbm-light dark:from-gray-800 dark:to-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center mb-4">
              <span className="text-3xl mr-3">🤝</span>
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 " style={{ fontFamily: 'Prompt, sans-serif' }}>Trusted by Leading Organizations</h2>
            </div>
            <p className="text-xl text-gray-600  max-w-3xl mx-auto font-normal">
              We work with government departments, municipalities, and private sector clients across South Africa
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center">
            {[1, 2, 3, 4, 5, 6].map((num) => (
              <div key={num} className="flex items-center justify-center p-6 bg-white  rounded-lg hover:shadow-lg transition-shadow">
                <img 
                  src={`/partners/zbm-partners (${num}).jpeg`}
                  alt={`Partner ${num}`}
                  className="max-h-20 w-auto object-contain grayscale hover:grayscale-0 transition-all"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20" style={{ background: 'linear-gradient(to right, #1E3A8A, #EA580C)' }}>
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6" style={{ fontFamily: 'Prompt, sans-serif' }}>
            Ready to Start Your Project?
          </h2>
          <p className="text-xl text-white mb-8 leading-relaxed font-normal" style={{ opacity: 0.95 }}>
            Contact us today to discuss your construction needs and get a detailed quote for your project.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact" className="bg-white text-zbm-primary hover:bg-gray-50 px-8 py-4 rounded-full text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer" style={{ fontFamily: 'Prompt, sans-serif' }}>
              Request a Quote
            </Link>
            <Link to="/products" className="border-2 border-white text-white hover:bg-white hover:text-zbm-primary px-8 py-4 rounded-full text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer" style={{ fontFamily: 'Prompt, sans-serif' }}>
              View Our Projects
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="lg:col-span-2">
              <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>
                ZBM Projects
              </h3>
              <p className="text-gray-300 mb-6 max-w-md font-normal">
                A 100% Black-owned private company specializing in prefabricated structures, civil and building construction projects. Delivering high-quality infrastructure solutions across South Africa.
              </p>
              <div className="flex space-x-4">
                <a href="#" className="w-10 h-10 bg-zbm-primary hover:bg-zbm-primary-dark rounded-full flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-facebook-fill"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-zbm-secondary hover:bg-zbm-secondary-dark rounded-full flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-linkedin-fill"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-whatsapp-line"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Services</h4>
              <ul className="space-y-2 text-gray-300 font-normal">
                <li><Link to="/services" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Project Management</Link></li>
                <li><Link to="/services" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Building Construction</Link></li>
                <li><Link to="/services" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Civil Engineering</Link></li>
                <li><Link to="/services" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Prefabricated Structures</Link></li>
                <li><Link to="/services" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Water Infrastructure</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Company</h4>
              <ul className="space-y-2 text-gray-300 font-normal">
                <li><Link to="/" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Home</Link></li>
                <li><Link to="/about" className="hover:text-zbm-primary-light transition-colors cursor-pointer">About Us</Link></li>
                <li><Link to="/about#team" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Our Team</Link></li>
                <li><Link to="/products" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Projects</Link></li>
                <li><Link to="/contact" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Contact Us</Link></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm font-normal">
              © 2025 ZBM Projects. All Rights Reserved. Reg: 2016/321746/07
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
